import { Configuration, PublicClientApplication } from '@azure/msal-browser';

import { ENV_CONFIG } from 'common/config/env.config';
/**
 * Configuration object to be passed to MSAL instance on creation.
 */
const msalConfig: Configuration = {
    auth: {
        clientId: ENV_CONFIG.CLIENT_ID,
        authority: ENV_CONFIG.AUTHORITY,
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin
    }
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const AUTH_SCOPES = {
    PROFILE: 'profile',
    OPENID: 'openid',
    EMAIL: 'email',
    USER_READ: 'User.Read'
};

export const authRequest = {
    scopes: [AUTH_SCOPES.PROFILE, AUTH_SCOPES.OPENID, AUTH_SCOPES.EMAIL, AUTH_SCOPES.USER_READ]
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const protectedResources = {
    graph: {
        endpoint: 'https://graph.microsoft.com/v1.0',
        scopes: [AUTH_SCOPES.USER_READ]
    },
    api: {
        endpoint: ENV_CONFIG.API_URL,
        scopes: authRequest.scopes
    }
};

export const mandatoryLogoutTimer = 1000 * 60 * 60 * 10; // 10 hours
